import { Dialog } from "@mui/material";
import React from "react";

import useWorkerSchedulerData from "../../../controllers/use-worker-scheduler-data";
import CallOffSection from "./call-off-section";

interface CallOffDialogProps {
	open: boolean;
  workerId: string;
	workerFullName: string;
  fromStatus: string;
	currentAssignment: {
		job: string;
		workcenter: string;
	};
	onConfirm: (callOffData: {
		ftRequestTypeId: number;
		ftLeaveTypes: {
      leaveTypeId: number;
      requestedHours: number;
    }[];
		ftSupervisorComment: string;
		ftStartDateTime: string;
		ftEndDateTime: string;
		ftFromStatus: string;
	}) => void;
	onCancel: () => void;
}

const CallOffDialog: React.FC<CallOffDialogProps> = ({
	open,
  workerId,
	workerFullName,
	currentAssignment,
  fromStatus,
	onConfirm,
	onCancel,
}) => {
  const { workerStatusTransitionDialog } = useWorkerSchedulerData();
  const { data } = workerStatusTransitionDialog;
  const shiftDetails = data?.shiftDetails;
	return (
		<Dialog
			open={open}
			onClose={onCancel}
			maxWidth='md'
			fullWidth
			aria-labelledby='call-off-dialog-title'
		>
			<CallOffSection
        workerId={workerId}
        fromStatus={fromStatus}
				workerFullName={workerFullName}
				currentAssignment={currentAssignment}
				onConfirm={onConfirm}
				onCancel={onCancel}
        shiftDetails={shiftDetails}
			/>
		</Dialog>
	);
};

export default CallOffDialog;
